export default __webpack_public_path__ + "static/media/spr-storyboarder-dark.851491e0.png";